/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Col, Row } from 'reactstrap';
import {
  footerMailingAddress,
  footerLegalLinks,
} from '@data/navigation';
import FooterImageLinkItem from './FooterImageLinkItem';
import FooterInformationItem from './FooterInformationItem';

const FooterPartners = ({ partnerLogosData }) => {
  const data = useStaticQuery(graphql`
    query {
      legacy: contentfulAsset(title: { eq: "Legacy Footer Logo" }) {
        description
        gatsbyImageData(height: 70, layout: FIXED)
      }
    }
  `);

  const { legacy } = data;

  return (
    <>
      {partnerLogosData ? (
        <Row>
          <Col className="text-center" md={12}>
            {partnerLogosData.partnerText1 && <p className="footer-heading pt-4">{partnerLogosData.partnerText1}</p>}
            {partnerLogosData.partnerLogo1 && (<div className="mb-4">
              {partnerLogosData.partnerLogo1.map((logo) => (
                <FooterImageLinkItem
                  link={logo.url}
                  image={logo.logoImage.gatsbyImageData}
                  alt="Partner Logo"
                  key={`${logo.title}`}
                  width={logo.width}
                  newTab={logo.newTab}
                />
              ))}
            </div>
            )}
            {partnerLogosData.partnerText2 && <p className="footer-heading pt-4">{partnerLogosData.partnerText2}</p>}
            {partnerLogosData.partnerLogo2 && (<div className="mb-4">
              {partnerLogosData.partnerLogo2.map((logo) => (
                <FooterImageLinkItem
                  link={logo.url}
                  image={logo.logoImage.gatsbyImageData}
                  alt="Partner Logo"
                  key={`${logo.title}`}
                  width={logo.width}
                  newTab={logo.newTab}
                />
              ))}
            </div>
            )}
          </Col>
        </Row>) : null}

      <Row>
        <Col className="text-center" md={12}>
          <div className="mb-0">
            {footerMailingAddress.map((mailingAddess, index) => (
              <FooterInformationItem
                key={`${mailingAddess.name}`}
                item={mailingAddess}
                isNotLastItem={index < footerMailingAddress.length - 1}
              />
            ))}
          </div>
        </Col>
      </Row>

      <Row>
        <Col className="text-center" md={12}>
          <div className="mb-3">
            {footerLegalLinks.map((legalLinks, index) => (
              <FooterInformationItem
                key={`${legalLinks.name}`}
                item={legalLinks}
                isNotLastItem={index < footerLegalLinks.length - 1}
              />
            ))}
          </div>
        </Col>
      </Row>

      <Row>
        <Col className="text-center" md={12}>
          <div>
            <FooterImageLinkItem
              ariaLabel="Read our clean water, land, and legacy amendment"
              link="https://www.smm.org/legacy"
              description={legacy.description}
              image={legacy}
              alt="Legacy Amendment Logo"
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FooterPartners;
